import { useContext } from "react";
import { Button, Card, OverlayTrigger, Tooltip } from "react-bootstrap";
import { AuthContext } from '../context/usercontext';
import {Cart} from 'react-bootstrap-icons';
import { CartContext } from "../context/cartcontext";

const Product = ({name, image, price, id}) => {
    const {cart, setCart} = useContext(CartContext);
    const {user} = useContext(AuthContext);

    const addItem = e => {
        e.preventDefault();
        var i = 0, flag = 0;
        var arr = [...cart];

        for (i = 0; i < arr.length; i++) {
            if (arr[i].id === id) {
                arr[i].count = arr[i].count + 1;
                setCart(arr);
                flag = flag + 1;
            }
        }
    
        if (flag === 0){
            setCart(prevCart => [...prevCart, {id : id, name : name, price : price, count : 1}])
        }
    }


    return(
        <Card border = 'secondary-dark' className = 'product'>
            <Card.Img variant = 'top' src={image} className = 'productImage' />
            <Card.Body>
                <Card.Title>{name}</Card.Title>
                <div className = 'productButtons'>
                    <h6>{price}</h6>

                    {
                        user ? (
                            <Button  variant = 'outline-dark' onClick = {addItem}>
                                <Cart />
                            </Button>
                        ) : (
                            <OverlayTrigger overlay = {<Tooltip id = 'tooltip-disabled'>Please login!</Tooltip>}>
                                <span className = 'd-inline-block'>
                                      <Button variant = 'outline-dark' disabled style={{ pointerEvents : 'none' }}>
                                          <Cart />
                                      </Button>
                                </span>
                            </OverlayTrigger>
                        )
                    }
            
                    
                    
                </div>
            </Card.Body>
        </Card>
    );
}

export default Product;